export interface RouteTreeModel {
  path: string;
}

export interface MainRouteTreeModel extends RouteTreeModel {
  children?: { [id: string]: RouteTreeModel };
}
